'use strict';

const Util = (function() {
  let lastUniqueId = 0;

  function calcHeight(el) {
    let height = el.offsetHeight;
    
    if (el.firstChild && Node.ELEMENT_NODE === el.firstChild.nodeType) {
      const mt = window.getComputedStyle(el.firstChild).marginTop;
      
      if (mt && mt.includes('px')) {
        height += parseInt(mt.replace('px', ''));
      }
    }
    
    if (el.lastChild && Node.ELEMENT_NODE === el.lastChild.nodeType) {
      const mb = window.getComputedStyle(el.lastChild).marginBottom;
  
      if (mb && mb.includes('px')) {
        height += parseInt(mb.replace('px', ''));
      }
    }
  
    return height;
  }

  /**
   * Creates either a NodeList or an Array from one of the following:
   *
   * * A selector string
   * * A node
   * * A node list
   */
  function elementsFrom(src) {
    if (typeof src === 'string') {
      return document.querySelectorAll(src);
    }
    else if (src instanceof Node) {
      return [ src ];
    }
    else if ((src instanceof NodeList) || (src instanceof Array)) {
      return src;
    }
    else {
      error.log("Could not convert to elements: ", src);
      return null;
    }
  }
  
  function uniqueId() {
    return 'pt-uniq-' + (lastUniqueId++);
  }
  
  function nodeFromIdOrNode(src) {
    if (typeof src === 'string') {
      return document.querySelector(`#${ src }`);
    }
    else if (src instanceof Node) {
      return src
    }

    error.log("Could not convert to node: ", src);
  }
    
  function undefinedToNull(val) {
    return (val === undefined) ? null : val;
  }
  
  function undefinedOrEmptyToNull(val) {
    return ((val === undefined) || (val === '')) ? null : val;
  }
  
  /**
   * Products an element from a "template element".  This is a simple javascript clone with a few conventions.
   * 
   * * Identified by an ID (the templateId parameter), which is removed in the clone
   * * Can have its style set to display:none, which is removed in the clone
   * * If the template has a class named "template", this class is removed (can be used as an alternative to display:none)
   */
  function elFromTemplate(templateId) {
    const template = (templateId instanceof Node) ? templateId : document.getElementById(templateId);

    // No element?  Graceful-ish failure by returning an empty div.  Usually I favour hard-fails but
    // a javascript error can prevent rendering the rest of the page so this can save devs from themselves
    // if a template is misnamed or misplaced.
    if (!template) {
      console.error(`Could not find template with ID '${ templateId }'`);
      const dummyEl = document.createElement('div');
      return dummyEl;
    }
    
    
    const el = template.cloneNode(true);
    el.removeAttribute('id');
    el.classList.remove('template');
    el.style.removeProperty('display');
    
    return el;
  }
  
  function throttle(fn, waitMs = 200) {
    let inThrottle, lastFn, lastTime;

    return function() {
      const context = this;
      const args = arguments;
      
      if (inThrottle) {
        const sinceLast = (Date.now() - lastTime);
        const triggerWait = Math.max(waitMs - sinceLast, 0);

        clearTimeout(lastFn);
        lastFn = setTimeout(function() {
          const sinceLastInner = (Date.now() - lastTime);
          
          if (sinceLastInner >= waitMs) {
            fn.apply(context, args);
            lastTime = Date.now();
          }
        }, triggerWait);
      }
      else {
        fn.apply(context, args);
        lastTime = Date.now();
        inThrottle = true;
      }
    };
  };
  
  function escHtml(raw) {
    return raw.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  }
   
  return {
    calcHeight,
    elementsFrom,
    elFromTemplate,
    escHtml,
    nodeFromIdOrNode,
    undefinedToNull,
    undefinedOrEmptyToNull,
    uniqueId
  }
})();

window.Plaintext = (window.Plaintext || {});
window.Plaintext.Util = Util;
export default Util;

/**
 * Copyright 2024 Plaintext Inc.
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
